var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "composer-voz-orb-wrap",
      class: _vm.classesDoOrb,
      style: _vm.estiloDoWrap,
      attrs: { "data-teste": "composer-voz-orb", "aria-hidden": "true" }
    },
    [
      _vm.mostrarRipples
        ? [
            _c("div", { staticClass: "composer-voz-orb-ripple" }),
            _c("div", {
              staticClass:
                "composer-voz-orb-ripple composer-voz-orb-ripple--delay"
            })
          ]
        : _vm._e(),
      _vm.mostrarArco
        ? _c("div", { staticClass: "composer-voz-orb-arco" })
        : _vm._e(),
      _c("div", { staticClass: "composer-voz-orb" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }